import './transactionPreset.commands'

import CreateTransactionView from '@/transaction/create-transaction/CreateTransactionView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {PanelContent} from '@tritt/multipanel'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

export const CREATE_TRANSACTION: PanelContent = {
    componentName: 'CreateTransaction',
    component: CreateTransactionView,
    meta: {requiresOrg: true, isSingleton: true}
}

const icon = 'i-mdi-file-document-plus'
const label = 'Nytt bilag'
const route = CREATE_TRANSACTION

const hotkey = 's'
registerHotkey(hotkey, CREATE_TRANSACTION)

registerNavigationCommand({
    route,
    label,
    icon,
    hotkey: hotkey
})

registerNavigationEntry(NavGroup.CREATE_ENTRY, {
    title: label,
    key: 'create-transaction',
    icon,
    target: route
})

registerRoute(route)
buildSimpleCrumb(route, label, icon)


